import preval from 'preval.macro';

export { getProductImageUrl } from './image.util';

export const buildDate = preval`module.exports = Date.now()`;
